var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',{attrs:{"title":"Machine status","standalone":true},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('MachineryStatusTable')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }